const $cache = {
    document: $(document)
};

/**
 * @function
 * @description - Add loading dots div and span to button after click and hide other spans from the button
 * @param {String} [element] - element where to insert the click
 */
function loadingDots(element) {
    $cache.document.on("click", element, function (event) {

        event.currentTarget.style.pointerEvents="none";
        DisableSpanInsideButtom(event.currentTarget);

        const divExists = document.querySelector(".loading-dots");

        if (divExists) {
            divExists.classList.toggle("d-none");
            return;
        }

        ComponentsCreation(event.currentTarget);

    });
}

/**
 * @function
 * @description - Create LoadingDots Component
 * @param {String} [element] - element where to insert the click
 */
function ComponentsCreation(element) {

    const dotDiv = document.createElement("div");
    dotDiv.classList.add("loading-dots");
    for (let span = 0; span < 3; span++) {
        const spanb = document.createElement("span");
        spanb.classList.add("span-loading-dots");
        dotDiv.appendChild(spanb);
    }

    element.appendChild(dotDiv);
}

/**
 * @function
 * @description - Disable content already inside the button before adding new Component
 * @param {String} [element] - element where to insert the click
 */
function DisableSpanInsideButtom(element) {

    const childSpan = element.getElementsByTagName("span");

    for (let span = 0; span < childSpan.length; span++) {
        if (!(childSpan[span].classList.contains("span-loading-dots"))) {
            childSpan[span].classList.toggle("d-none");
        }
    }
}

/**
 * @function
 * @description - Activate loadingDots without the click function
 * @param {String} [element] - element where to insert the click
 */
function loadingDotsActivation(element) {

    document.querySelector(element).disabled = true;
    document.querySelector(element).classList.add("disabled", "disabled-by-loading-dots");

    if (!document.querySelector(".loading-dots")) {
        const parentDiv = document.querySelector(element);
        DisableSpanInsideButtom(parentDiv);
        ComponentsCreation(parentDiv);
    }
}

/**
 * @function
 * @description - Remove loadingDots animation
 * @param {String} [element] - element where to insert the click
 */
function disableLoadingDots(element) {
    const loadingDots = element.querySelector(".loading-dots");
    if (loadingDots) {
        element.removeChild(loadingDots);
    }

    const childSpan = element.getElementsByTagName("span");

    for (let span = 0; span < childSpan.length; span++) {
        if (!(childSpan[span].classList.contains("span-loading-dots"))) {
            childSpan[span].classList.toggle("d-none", false);
        }
    }
}

export {
    loadingDots,
    loadingDotsActivation,
    disableLoadingDots
};
